import { GlobalStore } from "../stores/global";

export default () => {
  const config = GlobalStore.useState(c => c.config);
  if (!config) return;
  const { appStoreLink, playStoreLink } = config.storeLinks;
  var userAgent = navigator.userAgent || navigator.vendor;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return appStoreLink;
  }
  return playStoreLink;
};
